import {
  type BaseProps,
  type ComponentSize,
  type ComponentVariant,
  type ComponentAppearance,
} from 'src/modules/shared/types/component.type';

interface LoadingDotsProps extends BaseProps {
  size?: ComponentSize;
  dotClassName?: string;
}

const sizeClasses: Record<NonNullable<ComponentSize>, string> = {
  '2xs': 'h-1.5 w-1.5',
  xs: 'h-1.5 w-1.5',
  sm: 'h-1.5 w-1.5',
  md: 'h-2 w-2',
  lg: 'h-3 w-3',
};

const variantDotClasses: Record<NonNullable<ComponentVariant>, string> = {
  primary: 'bg-primary-600',
  secondary: 'bg-secondary-500',
  danger: 'bg-danger-500',
  warning: 'bg-warning-500',
  neutral: 'bg-neutral-600',
  success: 'bg-success-500',
  info: 'bg-blue-500',
  whatsapp: 'bg-green-500',
  call: 'bg-emerald-500',
  email: 'bg-indigo-500',
};

const appearanceOverrides: Record<NonNullable<ComponentAppearance>, string> = {
  filled: '',
  outline: 'bg-white',
  soft: '',
  ghost: '',
};

export const LoadingDots: React.FC<LoadingDotsProps> = ({
  className = '',
  dotClassName = '',
  size = 'sm',
  variant = 'primary',
  appearance = 'filled',
}) => {
  const dotSize = sizeClasses[size];
  const colorClass =
    appearanceOverrides[appearance] || variantDotClasses[variant];

  const dotBase =
    `${dotSize} rounded-full ${colorClass} ${dotClassName}`.trim();

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className={`${dotBase} animate-bounce [animation-delay:-.3s]`} />
      <span className={`${dotBase} animate-bounce [animation-delay:-.15s]`} />
      <span className={`${dotBase} animate-bounce`} />
    </span>
  );
};

export default LoadingDots;
